import React, { useState } from 'react';
import { ChevronLeft, ChevronRight, Warning, TrendingUp, TrendingDown, EventBusy, Cake, EventAvailable } from '@mui/icons-material';
 
const CustomerCards = ({ customer }) => {
  const [currentPage, setCurrentPage] = useState(1);
  const totalPages = 2;

  if (!customer) return null;

  // Function to properly parse date from "DD-MM-YYYY"
  const parseDate = (dateStr) => {
    if (!dateStr) return null;
    const [day, month, year] = dateStr.split('-').map(Number);
    return new Date(year, month - 1, day);
  };

  // Function to check if a date is in the current month
  const isCurrentMonth = (dateStr) => {
    const date = parseDate(dateStr);
    if (!date) return false;
    const today = new Date();
    console.log("Current Month", date.getFullYear() === today.getFullYear() && date.getMonth() === today.getMonth())
    return date.getFullYear() === today.getFullYear() && date.getMonth() === today.getMonth();
  };

  const getUpcomingBirthday = (dateStr) => {
    const date = parseDate(dateStr);
    if (!date) return null;
   
    const today = new Date();
    const currentYear = today.getFullYear();
   
    // Create this year's birthday
    const birthdayThisYear = new Date(currentYear, date.getMonth(), date.getDate());
   
    // If birthday this year has passed, look at next year's birthday
    if (birthdayThisYear < today) {
      return new Date(currentYear + 1, date.getMonth(), date.getDate());
    }
   
    return birthdayThisYear;
  };
 
  // Function to check if birthday is in current or next month
  const checkBirthdayProximity = (dateStr) => {
    const upcomingBirthday = getUpcomingBirthday(dateStr);
    if (!upcomingBirthday) return null;
 
    const today = new Date();
    const currentMonth = today.getMonth();
    const nextMonth = (currentMonth + 1) % 12;
    const birthdayMonth = upcomingBirthday.getMonth();
 
    if (birthdayMonth === currentMonth) return 'current';
    if (birthdayMonth === nextMonth) return 'next';
    return null;
  };

  // Function to check if a date is in the next month
  const isNextMonth = (dateStr) => {
    const date = parseDate(dateStr);
    if (!date) return false;
    const today = new Date();
    const nextMonth = new Date(today.getFullYear(), today.getMonth() + 1);
    console.log("Next Month:: ",date.getFullYear() === nextMonth.getFullYear() && date.getMonth() === nextMonth.getMonth())
    return date.getFullYear() === nextMonth.getFullYear() && date.getMonth() === nextMonth.getMonth();
  };

  // Function to get days until a date
  const getDaysUntil = (dateStr) => {
    const date = parseDate(dateStr);
    if (!date) return null;
    const today = new Date();
    today.setHours(0, 0, 0, 0); // Ignore time zone issues
    date.setHours(0, 0, 0, 0);
    return Math.ceil((date - today) / (1000 * 60 * 60 * 24));
  };

  // Function to parse CASA variance
  const parseCASAVariance = (variance) => {
    if (!variance) return null;
    return parseFloat(variance.replace('%', ''));
  };

  // Generate alerts based on customer data
  const alerts = [
    // Birthday Alert
    customer['Birthday'] && checkBirthdayProximity(customer['Birthday']) ? {
      id: 1,
      type: 'Birthday',
      severity: checkBirthdayProximity(customer['Birthday']) === 'current' ? 'high' : 'medium',
      icon: <Cake />,
      message: checkBirthdayProximity(customer['Birthday']) === 'current'
        ? `Customer's birthday is this month on ${customer['Birthday'].split('-').slice(0, 2).join('-')}`
        : `Customer's birthday is next month on ${customer['Birthday'].split('-').slice(0, 2).join('-')}`,
      color: 'yellow'
    } : null,

    // PL Expiration Alert
    customer['PL Expiration Date'] && getDaysUntil(customer['PL Expiration Date']) <= 60 ? {
      id: 2,
      type: 'PL Expiration',
      severity: getDaysUntil(customer['PL Expiration Date']) <= 30 ? 'high' : 'medium',
      icon: <EventBusy />,
      message: `Personal Loan expiring on ${customer['PL Expiration Date']} (${getDaysUntil(customer['PL Expiration Date'])} days remaining)`,
      color: getDaysUntil(customer['PL Expiration Date']) <= 30 ? 'red' : 'orange'
    } : null,

    // CASA Variance Alert
    customer['CASA Variance 3 Months'] ? {
      id: 3,
      type: 'CASA Balance Movement',
      severity: Math.abs(parseCASAVariance(customer['CASA Variance 3 Months'])) > 50 ? 'high' : 'medium',
      icon: parseCASAVariance(customer['CASA Variance 3 Months']) > 0 ? <TrendingUp /> : <TrendingDown />,
      message: `CASA balance has ${parseCASAVariance(customer['CASA Variance 3 Months']) > 0 ? 'increased' : 'decreased'} by ${customer['CASA Variance 3 Months']}`,
      color: parseCASAVariance(customer['CASA Variance 3 Months']) > 0 ? 'green' : 'red'
    } : null
  ].filter(alert => alert !== null); // Filtering out null values

  return (
    <div className="bg-[#1A1A1A] p-6 rounded-xl border border-[#2A2A2A] shadow-xl">
      <div className="flex justify-between items-center mb-6">
        <h3 className="text-lg font-semibold text-[#FFFFFF]">Customer Alerts</h3>
      </div>
    
      <div className="space-y-4">
        {alerts.map((alert) => (
          <div 
            key={alert.id} 
            className={`border rounded-lg p-4 flex items-center space-x-4 ${
              alert.severity === 'high' ? 'border-l-4 border-[#B4E50D]' : 'border-[#3A3A3A]'
            } bg-[#2A2A2A] border-[#3A3A3A]`}
          >
            <div className={`p-2 rounded-full ${
              alert.color === 'red' ? 'bg-[#FF6B6B] text-[#FFFFFF]' :
              alert.color === 'orange' ? 'bg-[#FFA726] text-[#0A0A0A]' :
              alert.color === 'green' ? 'bg-[#B4E50D] text-[#0A0A0A]' :
              alert.color === 'yellow' ? 'bg-[#FFD54F] text-[#0A0A0A]' :
              'bg-[#3A3A3A] text-[#FFFFFF]'
            }`}>
              {alert.icon}
            </div>
            <div className="flex-grow">
              <p className="font-medium text-[#FFFFFF]">{alert.type}</p>
              <p className="text-sm text-[#B0B0B0]">{alert.message}</p>
            </div>
            {alert.severity === 'high' && (
              <Warning className="text-[#B4E50D]" />
            )}
          </div>
        ))}
    
        {alerts.length === 0 && (
          <div className="text-center text-[#B0B0B0] py-4">
            No active alerts for this period
          </div>
        )}
      </div>
    </div>
  );
};
 
export default CustomerCards;